import React, { useState } from 'react'
import './style.scss'
import { Button, notification } from 'antd'
import Axios from 'axios'
import { useNavigate } from 'react-router-dom';
function ConfirmEmail() {
  const history = useNavigate();
  const [loadingBtnConfirmEmail, setLoadingBtnConfirmEmail] = useState(false)

  function onClickBtnConfirmEmail() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get('email');
    const token = urlParams.get('token');
    const userId = urlParams.get('personId');

    const objBodyConfirmEmail = {
      "email": email,
      "token": token,
      "personId": parseInt(userId)
    }
    setLoadingBtnConfirmEmail(true)
    serviceConfirmEmail(objBodyConfirmEmail)
  }

  async function serviceConfirmEmail(body) {
    try {
      const result = await Axios.post(`${process.env.REACT_APP_API_HOST}/auth/confirmEmail`, body , {
        headers:
        {
            "Content-Type":"application/json"
        } 
      });
      console.log('result', result)
      notification.success({
        message:"Success" , 
        description:"Successful"
      })
      setLoadingBtnConfirmEmail(false)
      history('/')
    } catch (error) {
      console.log('error', error)
      notification.error(
       {
         message:"Error" , 
         description:error?.response?.data?.message
       }
     )
      setLoadingBtnConfirmEmail(false)
    }
  }

  return (

    <div className='wrap-page-confirm-email'>
      <h1>Metaverse Service Confirm Email</h1>
      <Button loading={loadingBtnConfirmEmail} onClick={() => onClickBtnConfirmEmail()}>Confirm Email</Button>
    </div>

  )
}

export default ConfirmEmail